<!-- Card -->
<section class="card">
  <!-- Header -->
  <div class="card-header py-3">
    <h3 class="card-title">
      {{ 'general.roles' | translate }}
    </h3>
    <button
      type="button"
      class="btn btn-sm btn-primary"
      data-test-id="organization-user-role-add"
      (click)="onClickCreateUserRole()"
      [canSee]="[accessRights.Organizations_write]"
    >
      {{ 'general.add' | translate }}
    </button>
  </div>
  <!-- End Header -->

  <!-- Body -->

  <user-role-table
    [userRoleTableOptions]="{ hideOrganisation: true }"
    [tableData]="userRoles$ | async"
    [bulkActions]="[BulkAction.APPROVE, BulkAction.DETACH, BulkAction.EXPORT]"
    (onBulkAction)="onBulkAction($event)"
    (onClickRow)="onClickRow($event)"
  ></user-role-table>

  <!-- End Body -->
</section>
<!-- End Card -->
